export default {
  baseURL: 'http://www.wangshizongpu.com/api/home/',
  fileManagerPrefix: 'http://www.wangshizongpu.com/',
}



// WEBPACK FOOTER //
// ./src/config.js